module.exports = __webpack_public_path__ + "images/create-first-board/card-back/cardBack-tr.23221c838d6dc578fa60.svg";